import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createTeamRole, DIAM_API_PATH, DIAM_TEAM_ID } from '../../diamApi';
import { useApiEssentials } from '../../../../shared/hooks/useApiEssentials';
import { mapCreateRoleInclusions } from './mapCreateRoleInclusions';
import type { CreateRoleFormValues } from './types';
import type { DiamRoleDetails } from '../../diamApi';

export function useCreateTeamRole(functionalRoles: readonly DiamRoleDetails[]) {
  const { getIdToken, apiUrl } = useApiEssentials(DIAM_API_PATH);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CreateRoleFormValues) => {
      const idToken = await getIdToken();
      const inclusions = mapCreateRoleInclusions(
        data.contents,
        functionalRoles,
      );

      if (inclusions.length === 0) {
        throw new Error('Select at least one role or attribute');
      }

      return createTeamRole(apiUrl, idToken, data.teamId, {
        name: data.name.trim(),
        description: data.description.trim() || undefined,
        inclusions,
        modifiers: {},
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['diam', 'teams', DIAM_TEAM_ID, 'roles', 'page'],
      });
      queryClient.invalidateQueries({ queryKey: ['diam', 'roles', 'page'] });
    },
  });
}
